import { render, staticRenderFns } from "./ViewJsonDialog.vue?vue&type=template&id=669b8c63&"
import script from "./ViewJsonDialog.vue?vue&type=script&lang=js&"
export * from "./ViewJsonDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports